import type { FaireProductEntity } from "../../entity_types/product";

export const p_qg3f34g58y: FaireProductEntity = {
  token: "p_qg3f34g58y",
  type: "product",
  name: "EARLY POP - RESORT Mother of Pearl Kitten Heel ✈️SHIPS TODAY",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/0f8e4eda0eaa151b9408db4325e80552e881541ebdfdb59263077f470d2fe627.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b2dcbc0ec52083794546505d274c9a2c392e3d6b45371cc9678a1621605b74d9.jpeg",
    "https://cdn.faire.com/fastly/200c317f85feb63c3b5edabb04bce9740e6ddfe4850cf8ab17843ff9c02a75cd.jpeg",
    "https://cdn.faire.com/fastly/8cd6a05b609b57b85b8cd53d62ab54c00d4512b0589f6fdb3077d25eb5e41b1e.jpeg",
    "https://cdn.faire.com/fastly/67a05db96282cfe3b3b5c5308c540dd8a5af9b8cac5dd580ecd3483455470b46.jpeg",
    "https://cdn.faire.com/fastly/89429f4fe5fc94038db187ef7f0dce22e60fcc113941bcd9e4bc6f829035170e.jpeg",
    "https://cdn.faire.com/fastly/abfe38d51eaf1979e958f52053c8f142fcc8d15ac863c1a2b20864042e6d0a05.jpeg",
    "https://cdn.faire.com/fastly/58a6cf3c821a939f3e1a1e9b5bb16fe3411b4b017505e10df5580fd2007b374b.jpeg",
    "https://cdn.faire.com/fastly/76857e0414a7cb260a7d22ac362cf2009241cd69312d52d323f19743f6dd11ed.jpeg",
    "https://cdn.faire.com/fastly/cb42595a45f9df69e5bcaa37acb7bf8cf245777918f6333b199a514e0505e800.jpeg",
  ],
  priceDollars: 14.5,
  description:
    "Flirty, fun, and perfect for warm weather, EARLYPOP is topped with layered mother of pearl disc embellishments that catch the light with every step. Designed in green, chocolate, and yellow, it blends playful texture with an easy, feminine silhouette—ideal for everything from daytime outings to dressed-up evenings.\n**OOTD Idea:**\nChoose the green pair to brighten up a white sundress and woven bag for a soft, fresh look. The chocolate shade pairs effortlessly with tailored linen pants and a silky cami for a more elevated, evening vibe. For the yellow, style with a pastel mini skirt and fitted knit for a chic spring-forward outfit. Add simple gold jewelry to keep the focus on the shoes’ shimmer and movement.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:14.212Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
